module.exports = __webpack_public_path__ + "img/index-banner2.22b8c148.png";